import { render, staticRenderFns } from "./examTranscriptCard.vue?vue&type=template&id=22f57682&scoped=true"
import script from "./examTranscriptCard.vue?vue&type=script&lang=js"
export * from "./examTranscriptCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f57682",
  null
  
)

export default component.exports